import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import './Specialties.css';
import './SpecialtyDetail.css';

function formatPrice(p) {
  const n = Number(p);
  if (Number.isNaN(n)) return '';
  return `$${n.toFixed(2).replace(/\.00$/, '')}`;
}

export default function SpecialtyDetail() {
  const { slug } = useParams();
  const [specialty, setSpecialty] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setSpecialty(null);
    setError(false);
    fetch(`${API_BASE_URL}/api/specialties/${slug}`)
      .then((r) => {
        if (!r.ok) { if (!cancelled) setError(true); return null; }
        return r.json();
      })
      .then((data) => { if (data && !cancelled) setSpecialty(data); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [slug]);

  if (error) {
    return (
      <main className="specialty-detail-main">
        <div className="specialty-detail-notfound">
          <p>We couldn't find that specialty.</p>
          <Link to="/specialties">← Back to specialties</Link>
        </div>
      </main>
    );
  }

  if (!specialty) {
    return (
      <main className="specialty-detail-main">
        <div className="specialties-loading">Loading...</div>
      </main>
    );
  }

  const initial = (specialty.name || '?').charAt(0).toUpperCase();
  const price = formatPrice(specialty.price);
  return (
    <main className="specialty-detail-main">
      <Link to="/specialties" className="specialty-detail-back">← Back to specialties</Link>
      {specialty.image ? (
        <img className="specialty-detail-hero" src={specialty.image} alt={specialty.name} />
      ) : (
        <div className="specialty-detail-hero specialty-detail-hero-fallback" aria-hidden="true">{initial}</div>
      )}
      <h1 className="specialty-detail-name">{specialty.name}</h1>
      {(specialty.durationMinutes || price) && (
        <p className="specialty-detail-meta">
          {specialty.durationMinutes ? `${specialty.durationMinutes} min` : ''}
          {specialty.durationMinutes && price ? ' · ' : ''}
          {price}
        </p>
      )}
      {specialty.description && <p className="specialty-detail-desc">{specialty.description}</p>}
      <div className="specialty-detail-cta-row">
        <Link to={`/contact?specialty=${specialty.slug}`} className="specialty-detail-cta">
          Inquire about this specialty
        </Link>
      </div>
    </main>
  );
}
